import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const TONES = {
  deliverable: "bg-emerald-500/10 text-emerald-700 border-emerald-500/20",
  risky: "bg-rose-500/10 text-rose-700 border-rose-500/30",
  invalid: "bg-rose-600/15 text-rose-800 border-rose-600/30",
  unknown: "bg-slate-500/10 text-slate-600 border-slate-500/20",
};

export const isFlagged = (v) => v && (v.verdict === "risky" || v.verdict === "invalid");

export function ValidationBadge({ v, testId }) {
  if (!v) return <span className="text-[11px] text-muted-foreground" data-testid={testId}>not checked</span>;
  const notes = [v.reason_label, v.catch_all && "catch-all", v.role && "role inbox", v.disposable && "disposable",
    v.email_security?.length && `gateway: ${v.email_security.join(", ")}`].filter(Boolean).join(" · ");
  return (
    <span data-testid={testId} title={notes} className={`inline-flex items-center gap-1 text-[11px] font-mono px-2 py-0.5 rounded-full border ${TONES[v.verdict] || TONES.unknown}`}>
      {v.verdict}{v.score != null && <span className="opacity-70">{v.score}</span>}
    </span>
  );
}

export async function runValidation(emails) {
  try {
    const { data } = await api.post("/validate", { emails });
    const flagged = Object.values(data.results).filter(isFlagged).length;
    const credits = data.credits_remaining != null ? ` · ${data.credits_remaining} checks left` : "";
    if (data.quota_exhausted) toast.warning(`Validated ${data.checked + data.cached}, ${data.skipped} skipped`, { description: data.hint });
    else toast.success(`Validated ${data.checked + data.cached} address(es)${credits}`, { description: flagged ? `${flagged} flagged as risky or invalid` : "No risky addresses found" });
    return data.results;
  } catch (e) {
    toast.error(errMsg(e));
    return null;
  }
}
